
export default function addGoogleAnalyticsEventLog(eventName: string, params: any): void {
    try {
        console.log(`Sending event to Google Analytics: ${eventName}`, params);
        gtag('event', eventName, params);
    } catch (error) {
        console.error(error);
    }
}
